document.addEventListener("DOMContentLoaded", function () {
  initCarousels();
});


function initCarousels() {
  const carouselContainers = document.querySelectorAll(".gh-tag-carousel-container");

  carouselContainers.forEach((container) => {
    const carousel = container.querySelector(".gh-tag-carousel-posts");
    if (!carousel) return;

    // Adiciona botões de navegação
    const prevButton = document.createElement("button");
    prevButton.className = "gh-tag-carousel-nav-button prev";
    prevButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
    prevButton.setAttribute("aria-label", "Anterior");

    const nextButton = document.createElement("button");
    nextButton.className = "gh-tag-carousel-nav-button next";
    nextButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';
    nextButton.setAttribute("aria-label", "Próximo");

    container.appendChild(prevButton);
    container.appendChild(nextButton);
    // Configure carousel scrolling
    carousel.style.cursor = "grab";

    // Check initial button states
    checkButtonStates(carousel, prevButton, nextButton);

    // Event listeners for navigation buttons
    prevButton.addEventListener("click", () => {
      scrollCarousel(carousel, -300);
    });

    nextButton.addEventListener("click", () => {
      scrollCarousel(carousel, 300);
    });

    // Update button states when scrolling
    carousel.addEventListener("scroll", () => {
      checkButtonStates(carousel, prevButton, nextButton);
    });

    // Update button states when window is resized
    window.addEventListener("resize", () => {
      checkButtonStates(carousel, prevButton, nextButton);
    });

    // Drag scroll configuration
    let isDown = false;
    let startX;
    let scrollLeft;

    carousel.addEventListener("mousedown", (e) => {
      isDown = true;
      carousel.style.cursor = "grabbing";
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
      e.preventDefault();
    });

    carousel.addEventListener("mouseleave", () => {
      isDown = false;
      carousel.style.cursor = "grab";
    });

    carousel.addEventListener("mouseup", () => {
      isDown = false;
      carousel.style.cursor = "grab";
    });

    carousel.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.addEventListener("touchstart", (e) => {
      isDown = true;
      startX = e.touches[0].pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener("touchend", () => {
      isDown = false;
    });

    carousel.addEventListener("touchmove", (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    });
  });
}

function scrollCarousel(carousel, scrollAmount) {
  carousel.scrollBy({
    left: scrollAmount,
    behavior: "smooth"
  });
}

function checkButtonStates(carousel, prevButton, nextButton) {
  const scrollPosition = carousel.scrollLeft;
  const maxScrollPosition = carousel.scrollWidth - carousel.clientWidth;
  
  if (scrollPosition <= 0) {
    prevButton.classList.add("disabled");
  } else {
    prevButton.classList.remove("disabled");
  }
  
  if (scrollPosition >= maxScrollPosition - 5) {
    nextButton.classList.add("disabled");
  } else {
    nextButton.classList.remove("disabled");
  }
}
